import React, { useState } from 'react';

export function Login() {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle'); // idle, loading, sent, error
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');

        try {
            const response = await fetch('/api/auth/request-one-time-link', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });

            const data = await response.json();

            if (response.ok) {
                setStatus('sent');
                setMessage('Check your email for the login link!');
            } else {
                setStatus('error');
                setMessage(data.error || 'Something went wrong');
            }
        } catch (error) {
            setStatus('error');
            setMessage('Failed to send one-time link');
        }
    };

    return (
        <div className="login-container">
            <h1>Sign In to Ocuros Sandbox</h1>

            {status === 'sent' ? (
                <div className="success-message">
                    <h2>Check your email</h2>
                    <p>We've sent a login link to <strong>{email}</strong></p>
                    <p>Click the link in the email to sign in.</p>
                </div>
            ) : (
                <form onSubmit={handleSubmit}>
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={status === 'loading'}
                    />

                    <button
                        type="submit"
                        disabled={status === 'loading'}
                    >
                        {status === 'loading' ? 'Sending...' : 'Send One-Time Link'}
                    </button>
                </form>
            )}

            {status === 'error' && (
                <p className="error-message">{message}</p>
            )}
        </div>
    );
}
